<script lang="ts" setup>
import { SlidersPerView, SpaceBetweenSwiper } from '~/enums'
import { IMAGE_HR_BANNER_DEFAULT } from '~/constants'
import { useSwiper } from '~/composables/common/use-swiper'
import { useCommonStore } from '~/stores/common'
import { GAME_BANNERS } from '~/resources/common'
import type { BannersResponseData } from '@kira-dancer/nadal'

const { isMobile } = useDevice()
const { modules, SwiperSlide, Swiper } = useSwiper()
const { fetchBanners, banners, onClickBanner, jackpotXocdia } = useBanners()
const commonStore = useCommonStore()
const $isLighthouseBot = useNuxtApp().$isLighthouseBot as boolean

fetchBanners()

const isClosedSidebar = computed(() => commonStore.isClosedSidebar)


const getGameItem = (item: BannersResponseData) => {
  return {
    ...item,
    gameId: jackpotXocdia?.value?.gameId,
  } as BannersResponseData
}

const handleImageError = (index: number) => {
  if (banners?.value?.length && banners?.value[index]) {
    banners.value[index].imgSrc = IMAGE_HR_BANNER_DEFAULT
  }
}
</script>

<template>
  <div
    id="heroBanner"
    :class="[
      'hero-banner',
      {
        'hero-banner--mobile': isMobile,
      },
    ]"
  >
    <div v-if="banners?.length && !isMobile" class="swiper-arrow">
      <div class="swiper-arrow__prev swiper-button-prev">
        <span class="icon-arrow icon-left" />
      </div>
      <div class="swiper-arrow__next swiper-button-next">
        <span class="icon-arrow icon-right" />
      </div>
    </div>
    <Swiper
      :modules="modules"
      :slides-per-view="SlidersPerView.ExtraSmall"
      :space-between="SpaceBetweenSwiper.Zero"
      :mousewheel="{
        invert: true,
        sensitivity: 1,
      }"
      :autoplay="
        $isLighthouseBot
          ? false
          : {
              delay: 5000,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }
      "
      pause-on-mouse-enter
      :speed="500"
      loop
      :navigation="{
        nextEl: '.swiper-arrow__next',
        prevEl: '.swiper-arrow__prev',
      }"
      :pagination="{
        el: '.hr-banners-pagination',
        clickable: true,
      }"
    >
      <template v-if="jackpotXocdia?.gameId">
        <SwiperSlide
          v-for="(item, index) in GAME_BANNERS"
          :key="`${index}-game`"
        >
          <a href="#" @click.prevent="onClickBanner(getGameItem(item))">
            <div class="banner-image">
              <img
                :src="isMobile ? item?.imgSrcMobile : item?.imgSrc"
                :alt="`Banner ${index}`"
                width="1000"
                height="310"
                :class="[
                  'banner-jackpot',
                  {
                    'banner-closed-side-bard': isMobile && !isClosedSidebar,
                  },
                ]"
              />
              <div
                :class="[
                  'jackpot',
                  {
                    'is-closed-side-bard': !isMobile && isClosedSidebar,
                  },
                ]"
              >
                <div class="jackpot__content">
                  <BaseAnimatedNumber
                    class="jackpot__number"
                    :number="jackpotXocdia?.value"
                    :start="jackpotXocdia?.value"
                  />
                </div>
                <div class="jackpot__header">
                  <div class="jackpot__title">
                    {{ jackpotXocdia?.gameName }}
                  </div>
                </div>
              </div>
              <div class="shadow-bottom">
                <img
                  src="/images/home/rectangle-shadow-hr-banner.webp"
                  :alt="`Banner ${index} bottom shadow`"
                  loading="lazy"
                />
              </div>
            </div>
          </a>
        </SwiperSlide>
      </template>
      <SwiperSlide v-for="(item, index) in banners" :key="index">
        <a :href="item?.link" @click.prevent="onClickBanner(item)">
          <div class="banner-image">
            <img
              :src="item?.imgSrcMobile || item?.imgSrc"
              width="1000"
              height="310"
              :alt="`Banner ${index}`"
              loading="eager"
              @error="handleImageError(index)"
            />
            <div class="shadow-bottom">
              <img
                src="/images/home/rectangle-shadow-hr-banner.webp"
                :alt="`Banner ${index} bottom shadow`"
                loading="lazy"
              />
            </div>
          </div>
        </a>
      </SwiperSlide>
      <div :class="['hr-banners-pagination', { mobile: isMobile }]" />
    </Swiper>
  </div>
</template>
<style scoped lang="scss">
@import '~/assets/styles/components/desktop/home/hr-banner.scss';
</style>
